export default {
  'pages.layouts.userLayout.title': '锦标赛管理后台',
  'pages.login.accountLogin.errorMessage': '错误的用户名和密码(admin/ant.design)',
  'pages.login.failure': '登录失败，请重试！',
  'pages.login.success': '登录成功！',
  'pages.login.username.required': '用户名是必填项！',
  'pages.login.password.required': '密码是必填项！',
  'pages.login.dynamicPassword.required': '请输入动态口令！',
  'pages.login.submit': '确 定',
  'pages.login.loginSubmit': '登 录',
  'pages.login.backToAccount': '返回重新输入账号',
  'pages.login.bindTitle': '绑定动态口令',
  'pages.login.bindSuccess': '绑定成功',
  'pages.welcome.alertMessage': '更快更强的重型组件，已经发布。',
  'pages.404.subTitle': '抱歉，您访问的页面不存在。',
  'pages.404.buttonText': '返回首页',
  'pages.admin.subPage.title': ' 这个页面只有 admin 权限才能查看',
  'pages.searchTable.createForm.newRule': '新建规则',
  'pages.searchTable.updateForm.ruleConfig': '规则配置',
  'pages.searchTable.updateForm.basicConfig': '基本信息',
  'pages.searchTable.updateForm.ruleName.nameLabel': '规则名称',
  'pages.searchTable.updateForm.ruleName.nameRules': '请输入规则名称！',
  'pages.searchTable.updateForm.ruleDesc.descLabel': '规则描述',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder': '请输入至少五个字符',
  'pages.searchTable.updateForm.ruleDesc.descRules': '请输入至少五个字符的规则描述！',
  'pages.searchTable.updateForm.ruleProps.title': '配置规则属性',
  'pages.searchTable.updateForm.object': '监控对象',
  'pages.searchTable.updateForm.ruleProps.templateLabel': '规则模板',
  'pages.searchTable.updateForm.ruleProps.typeLabel': '规则类型',
  'pages.searchTable.updateForm.schedulingPeriod.title': '设定调度周期',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': '开始时间',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules': '请选择开始时间！',
  'pages.searchTable.titleDesc': '描述',
  'pages.searchTable.ruleName': '规则名称为必填项',
  'pages.searchTable.titleCallNo': '服务调用次数',
  'pages.searchTable.nameStatus.default': '关闭',
  'pages.searchTable.nameStatus.running': '运行中',
  'pages.searchTable.nameStatus.online': '已上线',
  'pages.searchTable.nameStatus.abnormal': '异常',
  'pages.searchTable.titleUpdatedAt': '上次调度时间',
  'pages.searchTable.exception': '请输入异常原因！',
  'pages.searchTable.titleOption': '操作',
  'pages.searchTable.config': '配置',
  'pages.searchTable.subscribeAlert': '订阅警报',
  'pages.searchTable.title': '查询表格',
  'pages.searchTable.new': '新建',
  'pages.searchTable.chosen': '已选择',
  'pages.searchTable.item': '项',
  'pages.searchTable.totalServiceCalls': '服务调用次数总计',
  'pages.searchTable.tenThousand': '万',
  'pages.searchTable.batchDeletion': '批量删除',
  'pages.searchTable.batchApproval': '批量审批',
  'pages.platform.bannerName': '轮播图名称',
  'pages.platform.bannerImage': '轮播图',
  'pages.platform.jumpLink': '跳转链接',
  'pages.platform.linkJump': '链接跳转',
  'pages.platform.internalJump': '站内跳转',
  'pages.platform.noJump': '不需跳转',
  'pages.platform.uploadTip': '只能上传jpg/png/webp/gif文件',
  'pages.platform.uploadError': '只能上传jpg/png/jpeg/webp文件',
  'pages.platform.chinese': '简体中文',
  'pages.platform.uploadImage': '请上传图片',
  'pages.platform.hallId': '大厅ID:',
  'pages.platform.input': '输入',
  'pages.platform.invitePage': '邀请页',
  'pages.platform.myAccount': '我的账号',
  'pages.platform.copy': '文案',
  'pages.platform.homePopup': '首页弹框',
  'pages.platform.homeMarquee': '首页跑马灯',
  'pages.platform.language': '语言',
};
